import { render } from "./KSDeleteNode.vue?vue&type=template&id=1a36681c"
import script from "./KSDeleteNode.vue?vue&type=script&lang=js"
export * from "./KSDeleteNode.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__